export const OVERVIEW_SECTION = 'overview';
export const SPACES_SECTION = 'spaces';
export const RECENT_ACTIVITY_SECTION = 'recent-activity';
export const TENANT_TOUR_SECTIONS = {
  OVERVIEW_SECTION,
  SPACES_SECTION,
  RECENT_ACTIVITY_SECTION,
};
